export default __webpack_public_path__ + "static/media/paymentSuccess.012784de.png";